<template>
    <v-container fluid>
        <v-row :style="{ marginTop: day_select == 'single' ? '-20px' : '-20px' }">
            <v-col cols="1" lg="1" md="1" style="margin-left: 50px;"/>
            <v-col cols="11" lg="8" md="8" >
            <span 
                style="color: #0A7EA5; font-size: 16px; cursor: pointer;" 
                @click="getBackList()"
                class="hover-back"
            >
            &lt;Back
            </span>
            </v-col>
        </v-row>

        <v-row style="margin-top: 20px;">
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;">
            <v-row>
                <v-col cols="12" lg="12" md="12" class="d-flex">
                <v-row>
                    <v-col cols="6" lg="6" md="6">
                    <span style="color: #222222; font-size: 25px; font-weight: 500;"></span>
                    </v-col>
                    <v-col cols="6" lg="6" md="6" class="d-flex align-center justify-end">
                    <span 
                        style="
                            color: #06A458; 
                            font-size: 25px; 
                            text-align: right; 
                        "  
                        v-if="leave_data.status_approve_name ==  'Approved'">
                        {{ leave_data.status_approve_name }}
                    </span> 
                    <span 
                        style="
                            color: red; 
                            font-size: 25px; 
                            text-align: right; 
                        "  
                        v-else-if="leave_data.status_approve_name ==  'Rejected'">
                        {{ leave_data.status_approve_name }}
                    </span> 
                    <span 
                        style="
                            color: #0A7EA5; 
                            font-size: 25px; 
                            text-align: right; 
                        "  
                        v-else>
                        {{ leave_data.status_approve_name }}
                        </span> 
                    </v-col>
                </v-row>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
        <v-row :style="{ marginTop: day_select == 'single' ? '10px' : '0px' }">
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;"  class="d-flex">
            <v-row>
                <v-col cols="6" lg="6" md="6" style="padding-right: 30px;">
                <span style="color: #222222; font-size: 18px;">Leave Type</span>
                <v-text-field
                    class="pt-2"
                    v-model="leave_data.leaveTypeId"
                    outlined
                    dense
                    disabled
                ></v-text-field>
                </v-col>
                <v-col cols="6" lg="6" md="6" style="padding-left: 30px;" v-if="day_select == 'single'">
                <v-row class="align-end">
                    <v-col cols="6" lg="6" md="6">
                    <span style="color: #222222; font-size: 18px;">Date</span>
                    <v-menu
                        
                        ref="menu_start"
                        v-model="menu_start"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            class="pt-2"
                            v-model="computedDateFromFormatted"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            disabled
                        ></v-text-field>
                        </template>
                        <v-date-picker 
                        v-model="leave_data.startDate" 
                        no-title scrollable 
                        />
    
                    </v-menu>
                    </v-col>
                    <v-col cols="6" lg="6" md="6">
                    <v-select
                        class="pt-2"
                        v-model="leave_start_hours"
                        fluid
                        item-text="text"
                        item-value="value"
                        :items="leave_hours"
                        outlined
                        dense
                        disabled
                    ></v-select>
                    </v-col>
                </v-row>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
        <v-row :style="{ marginTop: day_select == 'single' ? '-30px' : '-30px ' }" v-if="day_select == 'multiple'">
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;"  class="d-flex">
            <v-row>
                <v-col cols="6" lg="6" md="6" style="padding-right: 30px;">
                <v-row class="align-end">
                    <v-col cols="6" lg="6" md="6">
                    <span style="color: #222222; font-size: 18px;">From</span>
                    <v-menu
                        
                        ref="menu_start"
                        v-model="menu_start"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            class="pt-2"
                            v-model="computedDateFromFormatted"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            disabled
                        ></v-text-field>
                        </template>
                        <v-date-picker 
                        v-model="leave_data.startDate" 
                        no-title scrollable 
                        />
    
                    </v-menu>
                    </v-col>
                    <v-col cols="6" lg="6" md="6">
                    <v-select
                        class="pt-2"
                        v-model="leave_start_hours"
                        fluid
                        item-text="text"
                        item-value="value"
                        :items="leave_hours"
                        outlined
                        dense
                        disabled
                    ></v-select>
                    </v-col>
                </v-row>
                </v-col>
                <v-col cols="6" lg="6" md="6" style="padding-left: 30px;">
                <v-row class="align-end">
                    <v-col cols="6" lg="6" md="6">
                    <span style="color: #222222; font-size: 18px;">To</span>
                    <v-menu
                        ref="menu_end"
                        v-model="menu_end"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            class="pt-2"
                            v-model="computedDateToFormatted"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            disabled
                        ></v-text-field>
                        </template>
                        <v-date-picker 
                        v-model="leave_data.endDate" 
                        no-title scrollable 
                        />
                        
                    </v-menu>
                    </v-col>
                    <v-col cols="6" lg="6" md="6">
                    <v-select
                        class="pt-2"
                        v-model="leave_end_hours"

                        fluid
                        item-text="text"
                        item-value="value"
                        :items="leave_hours"
                        outlined
                        dense
                        disabled
                    ></v-select>
                    </v-col>
                </v-row>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
        <v-row :style="{ marginTop: day_select == 'single' ? '-30px' : '-30px ' }" v-if="!day_select">
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;"  class="d-flex">
            <v-row>
                <v-col cols="6" lg="6" md="6" style="padding-right: 30px;">
                <v-row class="align-end">
                    <v-col cols="6" lg="6" md="6">
                    <span style="color: #222222; font-size: 18px;">From</span>
                    <v-menu
                        
                        ref="menu_start"
                        v-model="menu_start"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            class="pt-2"
                            v-model="computedDateFromFormatted"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            disabled
                        ></v-text-field>
                        </template>
                        <v-date-picker 
                        v-model="leave_data.startDate" 
                        no-title scrollable 
                        />
    
                    </v-menu>
                    </v-col>
                    <v-col cols="6" lg="6" md="6">
                        <v-text-field
                            class="pt-2"
                            v-model="str_m_time"
                            outlined
                            dense
                            disabled
                        ></v-text-field>
                    </v-col>
                </v-row>
                </v-col>
                <v-col cols="6" lg="6" md="6" style="padding-left: 30px;">
                    <v-row class="align-end">
                        <v-col cols="6" lg="6" md="6">
                        <span style="color: #222222; font-size: 18px;">To</span>
                        <v-menu
                            ref="menu_end"
                            v-model="menu_end"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                class="pt-2"
                                v-model="computedDateToFormatted"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                dense
                                disabled
                            ></v-text-field>
                            </template>
                            <v-date-picker 
                            v-model="leave_data.endDate" 
                            no-title scrollable 
                            />
                            
                        </v-menu>
                        </v-col>
                        <v-col cols="6" lg="6" md="6">
                            <v-text-field
                                class="pt-2"
                                v-model="end_m_time"
                                outlined
                                dense
                                disabled
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
        <v-row style="margin-top: -30px;">
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;"  class="d-flex">
            <v-row>
                <v-col cols="12" lg="12" md="12">
                <span style="color: #222222; font-size: 16px;">({{ this.amountShow }})</span>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
        <v-row :style="{ marginTop: day_select == 'single' ? '10px' : '10px'}">
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;"  class="d-flex">
            <v-row>
                <v-col cols="12" lg="12" md="12">
                <v-textarea
                    outlined
                    v-model="leave_data.description"
                    label="Note Requester"
                    disabled
                    rows="2"
                ></v-textarea>
                </v-col>
            </v-row>
            </v-col>
        </v-row>        
        <v-row :style="{ marginTop: day_select == 'single' ? '-30px' : '-30px' }">
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;"  class="d-flex">
            <v-row>
                <v-col cols="12" lg="12" md="12">
                <v-textarea
                    ref="description"
                    outlined
                    v-model="leave_data.description_approve"
                    label="Note Approver"
                    rows="2"
                    disabled
                ></v-textarea>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
        <v-row :style="{ marginTop: day_select == 'single' ? '-50px' : '-30px ' }" v-if="oldpreview_list.length > 0"> 
            <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto; "  class="d-flex" >
                <v-card style="width: 100%;">  
                <template>
                    <div class="border pa-10">
                    <template >
    
                        <v-row class="your-target-div-here" id="mydiv">
                        <v-col
                            v-for="(item, index) in oldpreview_list"
                            :key="index"
                            class="d-flex child-flex"
                            cols="3"
                        >
                            <v-img
                            disabled
                            :src="item"
                            class="grey lighten-2 mt-3 mb-5"
                            aspect-ratio="1"
                            contain
                            @click="deleteItemConfirm(item)"
                            >
                            </v-img>
                            <!-- <p class="mb-0">file name: {{ image_list[index].name }}</p>
                            <p>size: {{ image_list[index].size / 1024 }}KB</p> -->
                        </v-col>
                        </v-row>
    
                        <template>
                        <div>
                            <!--  :pdf-margin="20"
                                pdf-content-width="720px" -->
                            <vue-html2pdf
                            :show-layout="false"
                            :float-layout="true"
                            :enable-download="true"
                            :preview-modal="false"
                            :paginate-elements-by-height="1100"
                            filename="meeting_vote_report"
                            :pdf-quality="2"
                            :manual-pagination="false"
                            pdf-format="a4"
                            pdf-orientation="portrait"
                            @progress="onProgress($event)"
                            @hasStartedGeneration="hasStartedGeneration()"
                            @hasGenerated="hasGenerated($event)"
                            ref="html2Pdf"
                            >
                            <!-- :html-to-pdf-options="htmlToPdfOptions" -->
                            <section slot="pdf-content">
                                <v-row>
                                <v-col
                                    v-for="(item, index) in oldpreview_list"
                                    :key="index"
                                    class="d-flex child-flex"
                                    cols="12"
                                >
                                    <v-img
                                    eager
                                    disabled
                                    :src="item"
                                    class="grey lighten-2 mt-3 mb-5"
                                    aspect-ratio="1"
                                    contain
                                    >
                                    </v-img>
                                </v-col>
                                </v-row>
    
                                <!-- PDF Content Here -->
                            </section>
                            </vue-html2pdf>
                        </div>
                        </template>
                    </template>
                    </div>
                </template>
                </v-card>
            </v-col>
        </v-row>
     
  
  
  
        <!-- <div>
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn 
                depressed 
                class="mr-5"                   
                style="
                      color: white;
                      background-color: #0A7EA5;
                      width: 200px;
                " 
                @click="onSave"
              >
                Approve
              </v-btn>
  
              <v-btn 
                depressed 
                class="mr-5"                   
                style="
                  color: red;
                  width: 200px;
                  border: 1px solid red;
                " 
                @click="onReject"
              >
                Reject Leave
              </v-btn>
            </v-col>
            <v-col align="center" cols="12" md="2"> </v-col>
          </v-row>
        </div>
   -->
        <v-dialog v-model="dialogDelete" scrollable max-width="50%">
        <v-card>
          <!-- <v-card-title class="text-h5"
                        >Are you sure you want to delete this item?</v-card-title
                      > -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn right color="red" text>
              <v-icon x-large color="red">mdi-close</v-icon></v-btn
            >
          </v-card-actions>
          <v-img
            :src="imageshowpopup"
            class="grey lighten-2 mt-3 mb-5"
            aspect-ratio="1"
            contain
          >
          </v-img>
        </v-card>
      </v-dialog>
  
      <SuccessDialog
          :status="dialogAdd"
          :text_color="text_color"
          :title="title"
          :message="message"
        />
      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
    </v-container>
</template>
  
<script>
    import api from "@/services/api";
    import { server, imageUrl } from "@/services/constants";
    import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
    import SuccessDialog from "@/components/cards/SuccessDialog";
    import html2pdf from "html2pdf.js";
    import VueHtml2pdf from "vue-html2pdf";
    import unity from "@/unity/unity";
    
    export default {
        name: "approve-leave-confirm",
        components: { SuccessDialogPush, SuccessDialog,VueHtml2pdf },
        data(vm) {
            return {
                str_m_time: "",
                end_m_time: "",
                image_show: "",
                day_select: "multiple",
                leave_hours: [
                { text: "1 hour", value: 1 },
                { text: "2 hours", value: 2 },
                { text: "3 hours", value: 3 },
                { text: "Half day", value: 4 },
                { text: "5 hours", value: 5 },
                { text: "6 hours", value: 6 },
                { text: "7 hours", value: 7 },
                { text: "Full day", value: 8 },
                ],
                menu_start: false,
                menu_end: false,
                leave_start_hours: "",
                leave_end_hours: "",
                dialogConfirm: false,
                approve_end_flow_status: false,
                approve_detail_data: [],
                imageshowpopup: "",
                fullName: "",
                employee_id: "",
                dialogDelete: false,
                dialogSave: false,
                dialogReject: false,
                preview: null,
                image: null,
                preview_list: [],
                oldpreview_list: [],
                image_list: [],
                menu: false,
                menu2: false,
                search: "",
                toggleEnable: false,
                selectstatus: "",
                dropdownLeave: [],
                dataAll: [],
                mDataArray: [],
                amountShow: "",
                leave_data: {
                leaveType: 0,
                leaveTypeId: 0,
                approve_id_now: 0,
                startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10),
                endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10),
                description: "",
                description_approve: "",
                status_approve_name: "",
                userId: 0,
                departmentId: 0,
                companyId: 0,
                amount: 0,
                images: null,
                lq_id: 0,
                },
                dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),

                dialogAdd: false,
                text_color: "text-h5 green--text text-center",
                title: "green",
                message: "green",
                link: "",
            };
        },
    
        watch: {
            dialog(val) {
                val || this.close();
            },
            dialogDelete(val) {
                val || this.closeDelete();
            },
        },
        computed: {
            computedDateFromFormatted() {
                return unity.formatDate(this.leave_data.startDate);
            },
            computedDateToFormatted() {
                return unity.formatDate(this.leave_data.endDate);
            },
        },
        async beforeCreate() {
            this.$store.state.navMenu = true;
        },
        async mounted() {
            await api.checkVersion();
            this.$store.state.global_dialog_push = false;
            this.$store.state.global_dialog = false;

            this.userId = localStorage.getItem(server.USER_ID);

            await this.loadDataLeave();
            this.$hideLoader();
        },
    
        methods: {
            async closeDelete(){
                this.dialogDelete = false;
            },
            async getBackList(){
                if(this.$route.params.mode == "approverhistory"){
                    this.$router.push(`/approver-time-off-history`);
                }else{
                    this.$router.push(`/my-time-off`); 
                }
                
            },
            async loadDataLeave(){
                const res_leave = await api.getLeaveHistoryByIDWaiting( this.$route.params.id)
                // console.log("res_leave.data: ")
                // console.log(res_leave.data)

                this.leave_data.leaveTypeId =  res_leave.data[0].leave_name;
                this.day_select = res_leave.data[0].type_count;
                this.leave_data.startDate = res_leave.data[0].startdate_s;
                this.leave_start_hours = Number(res_leave.data[0].starthour);
                this.leave_data.endDate = res_leave.data[0].enddate_s;
                this.leave_end_hours = res_leave.data[0].endhour;
                this.leave_data.description = res_leave.data[0].description;
                this.leave_data.description_approve = res_leave.data[0].remark_detail;
                this.leave_data.status_approve_name = res_leave.data[0].approve_name;
                this.str_m_time = res_leave.data[0].t_startdate_s;
                this.end_m_time = res_leave.data[0].t_enddate_s;
                
                var amount = 0;
                var leave_day = 0;
                var leave_hours = 0;

                amount = Number(res_leave.data[0].amount)/60;
                leave_day = Math.floor(amount / 8);
                leave_hours = amount - (leave_day * 8);

                this.amountShow = `${leave_day} day ${leave_hours} hours`;

                let setiamggfile = res_leave.data[0].preview_image.split(",");
                    if (setiamggfile[0] == "") {
                    } else {
                        setiamggfile.forEach((x) => {
                            this.oldpreview_list.push(`${imageUrl}/${x}`);
                        });
                    }
                
            },
            exportToPDF() {
                this.$refs.html2Pdf.generatePdf();
            },
            setupAlertDialog(status, title, message, text_color) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
            },
            setupAlertDialogPush(status, title, message, text_color, link) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
                this.link = link;
            },
            previewMultiImage: function(event) {
                var input = event.target;
                var count = input.files.length;
                var index = 0;
                if (input.files) {
                while (count--) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                    this.preview_list.push(e.target.result);
                    };
                    if (input.files[index].type.split("/")[0] === "image") {
                    this.image_list.push(input.files[index]);
                    reader.readAsDataURL(input.files[index]);
                    }
                    index++;
                }
                }
            },
            deleteItemConfirm(imageurl) {
                // this.indeximage = index;
                this.imageshowpopup = imageurl;
                this.dialogDelete = true;
            },
        },
    };
</script>
  
<style scoped>
    .hover-back {
        transition: color 0.3s ease; /* เพิ่มการเคลื่อนไหว */
    }
    
    .hover-back:hover {
        color: #6edbff !important; /* เปลี่ยนเป็นสีน้ำเงินเข้มเมื่อ hover */
    }
    .v-btn:not(.v-btn--round).v-size--default.buttonblue {
        background-color: #1d2442;
        color: white;
    }
    
    .v-textarea:not(.v-textarea--round).v-size--default.buttongreen {
        background-color: #09b534;
        color: white;
    }
    
    .textarea {
        border: 2px solid;
        border-color: #09b534;
    }
    
    .heightsize55 {
        height: 55px;
    }
    
    .heightsize80 {
        height: 80px;
    }
    
    .heightsize30 {
        height: 30px;
    }
    
    .inputsize {
        font-size: smaller;
    }
    .btnuploadfile {
        border: 2px solid;
    }
    .heightsize70formadvance {
        height: 70px;
    }
</style>
  